// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthAmenityType\ApiBerthAmenityType.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthAmenity, BerthAmenityData, BerthAmenityOptions } from 'data/models/BerthAmenity';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';
import { TopicCardTemplate, TopicCardTemplateData, TopicCardTemplateOptions } from 'data/models/TopicCardTemplate';

// BerthAmenityTypeData is the class that BerthAmenityType serializes to/from
export interface BerthAmenityTypeData {
    Id : number;
    Url : string | null;
	
    Berths : BerthAmenityData[] | null;
    Organization : OrganizationData | null;
    OrganizationId : number;
    TopicCards : TopicCardData[] | null;
    TopicCardTemplates : TopicCardTemplateData[] | null;
	
    Active : boolean;
    Description : string | null;
    Guid : /* GUID */ string;
    Name : string;
    Order : number;
}

// BerthAmenityTypeOptions is the class which may be passed to the BerthAmenityType constructor to define optional initial data values
export interface BerthAmenityTypeOptions {
    Id : number;
    Url? : string | null;
	
    Berths? : BerthAmenityOptions[] | null;
    Organization? : OrganizationOptions | null;
    OrganizationId? : number;
    TopicCards? : TopicCardOptions[] | null;
    TopicCardTemplates? : TopicCardTemplateOptions[] | null;
	
    Active? : boolean;
    Description? : string | null;
    Guid? : /* GUID */ string;
    Name? : string;
    Order? : number;
}

export class BerthAmenityType {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Berths : SDataArray<BerthAmenity>;
    public Organization : DataSignal<Organization | null>;
    public OrganizationId : DataSignal<number>;
    public TopicCards : SDataArray<TopicCard>;
    public TopicCardTemplates : SDataArray<TopicCardTemplate>;
	
    public Active : DataSignal<boolean>;
    public Description : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public Name : DataSignal<string>;
    public Order : DataSignal<number>;

    constructor();
    constructor(data : BerthAmenityTypeOptions);
    constructor(data: BerthAmenityTypeOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Berths = SArray<BerthAmenity>([]);
        this.Organization = S.value<Organization | null>(null);
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.TopicCards = SArray<TopicCard>([]);
        this.TopicCardTemplates = SArray<TopicCardTemplate>([]);
	    
        this.Active = jsonableObservable(S.value<boolean>(data && data.Active !== undefined ? data.Active : false));
        this.Description = jsonableObservable(S.value<string | null>(data && data.Description !== undefined ? data.Description : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
        this.Order = jsonableObservable(S.value<number>(data && data.Order !== undefined ? data.Order : 0));
    }

    static key(obj : BerthAmenityType) {
        return obj.Id();
    }
    
    static dataKey(obj : BerthAmenityTypeOptions) {
        return obj.Id;
    }

    static update(obj : BerthAmenityType, data : BerthAmenityTypeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
            if (data.Active !== undefined) obj.Active(data.Active);
            if (data.Description !== undefined) obj.Description(data.Description);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.Order !== undefined) obj.Order(data.Order);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BerthAmenityType.ts